import { createFileRoute } from '@tanstack/react-router'
import { AcceptInvitationForm } from '@/features/auth/accept-invitation'

/**
 * Route shell. Definition and guards only — the form lives in a feature.
 *
 * PUBLIC route, deliberately outside `_authenticated/`: the invitee has no
 * session yet — the token in the link IS the credential. The invitation
 * email (built by InvitationNotification in the Identity module) links to
 * `/accept-invitation?token=…&email=…`. Both are typed as optional in the
 * search shape so the form can render even if the user arrives without them
 * — a missing token surfaces as a 422 on submit rather than a blank screen.
 */
export const Route = createFileRoute('/accept-invitation')({
  component: AcceptInvitationForm,
  validateSearch: (search: Record<string, unknown>): { token?: string; email?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
    email: typeof search.email === 'string' ? search.email : undefined,
  }),
})
